<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 210px'>
        <p>供应商：</p>
        <el-input v-model='entrustIpt' size='mini' style='width:150px' placeholder='请输入供应商名称' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p>登录手机号：</p>
        <el-input v-model='tellIpt' size='mini' style='width:150px' placeholder='请输入登录手机号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>所在区域：</p>
        <el-cascader v-model='enterIpt' filterable :options='regionList' style='width:150px'
                     :props="{
                        expandTrigger: 'hover',
                        value: 'id',
                        label: 'cityName',
                        children: 'children',
                        multiple: false,
                      }" size='mini' collapse-tags clearable placeholder='请选择所在区域'
                     ref='areaCascader' />
      </div>
      <div class='navContainer'>
        <p>状态：</p>
        <el-select v-model='stateIpt' size='mini' filterable style='width:150px' placeholder='请选择'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='account' label='登录账号' align='center' />
          <el-table-column prop='name' label='供应商名称' align='center' show-overflow-tooltip />
          <el-table-column prop='serviceRegionName' label='服务区域' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='address' label='详细地址' align='center' show-overflow-tooltip />
          <!-- <el-table-column prop="leader" label="对接人姓名" align="center" width="100%"/> -->
          <el-table-column prop='examine' label='审核状态' align='center' width='70'>
            <div slot-scope='scope'>{{ getState(scope.row.examine, scope.row.operationPower) }}
            </div>
          </el-table-column>
          <el-table-column prop='examine' label='操作类型' align='center' width='65'>
            <div slot-scope='scope'>{{ operationTypeFormat(scope.row.operationType) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='205' align='center'>
            <template slot-scope='scope'>
              <div style='align-items:center;padding-left: 10px'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id,scope.row.operationPower)'>详情
                </el-button>
                <el-button v-if='scope.row.examine===1 && scope.row.operationPower===1' size='mini'
                           type='primary' @click='enableClick(scope.row.id)'>同意
                </el-button>
                <el-button v-if='scope.row.examine===1 && scope.row.operationPower===1' size='mini'
                           type='danger' @click='disableClick(scope.row.id)'>拒绝
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情供应商' :visible.sync='detailDialogVisible' width='600px' center top='10vh'
               :close-on-click-modal='false'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p :style='getStyle(detailData.examine)'>{{ getState(detailData.examine) }}</p>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商名称：</span>
              <span>{{ detailData.name }}</span>
            </div>
            <!--            <div class="baseInfoContentItem">-->
            <!--              <span class="span1">关键词：</span>-->
            <!--              <span>{{detailData.keyword}}</span>-->
            <!--            </div>-->
            <div class='baseInfoContentItem'>
              <span class='span1'>登录手机号：</span>
              <span>{{ detailData.account }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>服务区域：</span>
              <span v-for='(item,index) in detailData.typeName' :key='index'>{{ item }}<span
                v-if='index!==detailData.typeName.length-1'>、</span></span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>详细地址：</span>
              <span>{{ detailData.address }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>邮箱：</span>
                <span>{{ detailData.mailBox }}</span>
              </div>
              <div>
                <span class='span1'>电话：</span>
                <span>{{ detailData.phone }}</span>
              </div>
            </div>
            <div v-for='(item,index) in detailData.person' :key='index'>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>对接人姓名：</span>
                  <span>{{ item.name }}</span>
                </div>
                <div>
                  <span class='span1'>对接人手机：</span>
                  <span>{{ item.tell }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>对接人职位：</span>
                <span>{{ item.position }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>物流属性：</span>
              <span>
              {{
                  detailData.logisticsAttribute !== null ? (detailData.logisticsAttribute === 0 ? '民生' : '非民生') : ''
                }}
            </span>
            </div>
          </div>
        </div>
        <div class='baseInfo' v-if='detailData.attachData && detailData.attachData.length > 0'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>附件信息</span>
          </div>
          <div class='attachment'>
            <div>
              <div v-for='(item,index) in detailData.attachData' class='attachmentItem'
                   :key='index'>
                <span style='text-decoration: underline;cursor: pointer;'
                      @click='imgClick(item,item.name)'>{{ item.name }}</span>
                <span>{{ item.time }}</span>
                <span> <i class='el-icon-download' @click='downloadClick(item.id)'></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>审核信息</span>
          </div>
          <steps :step-data='stepData' :step-state='stepState' />
        </div>
        <!--        <div class="baseInfo" v-if="detailData.operationPower===1 && detailData.examine===1">-->
        <!--          <div class="baseInfoTitle">-->
        <!--            <div class="line"/>-->
        <!--            <span>操作</span>-->
        <!--          </div>-->
        <!--          <div class="baseInfoContentItem">-->
        <!--            <div style="display: flex;margin:10px 20px 0 15px;">-->
        <!--              <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>-->
        <!--              <el-input-->
        <!--                type="textarea"-->
        <!--                :style="'width:100%'"-->
        <!--                v-model="remark"-->
        <!--                placeholder="请填写同意/拒绝原因"-->
        <!--                autocomplete="off"-->
        <!--                size="small"-->
        <!--              />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div style='display: flex;align-items: center;justify-content: center'
             v-if='detailData.operationPower===1 && detailData.examine===1'>
          <el-button size='medium' type='primary' @click='agreeClick'>同意</el-button>
          <el-button size='medium' type='danger' @click='refusedClick'>拒绝</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='reasonTitle' :visible.sync='reasonVisible' width='550px' center
               :close-on-click-modal='false' top='30vh'>
      <div class='reasonContainer'>
        <div style='display: flex;padding-bottom: 20px;'>
          <span class='span1' style='width: 70px;'><span style='color:red'>*</span>原因：</span>
          <el-input
            type='textarea'
            style='width:100%;'
            v-model='reason'
            placeholder='请填写同意/拒绝原因'
            autocomplete='off'
            size='small'
          />
        </div>
        <div class='reasonBtn'>
          <el-button size='medium' class='searchBtn' type='primary' @click='reasonClick'>确认
          </el-button>
          <el-button size='medium' class='resetBtn' type='danger' @click='reasonVisible=false'>取消
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog center title='附件详情' :visible.sync='imgDialogVisible' width='200px;' append-to-body>
      <img style='width:100%;object-fit:cover' :src='dialogImageUrl' alt=''>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import {
    highwaySupplierAuditPageList,
    highwaySupplierAuditDetail,
    highwaySupplierReviewSubmit,
  } from '@/service/audit';
  import { baseImgUrl, baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    components: {
      steps,
    },
    data() {
      return {
        entrustIpt: '',
        tellIpt: '',
        enterIpt: '',
        stateIpt: '',
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '待审核',
          },
          {
            value: 2,
            label: '已通过',
          },
          {
            value: 3,
            label: '已拒绝',
          },
          {
            value: 4,
            label: '已取消',
          },
        ],
        regionList: [],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        remark: '',
        stepData: [
          // {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          // {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          // {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          // {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],
        reasonVisible: false,
        reasonTitle: '',
        reason: '',
        activeId: '',
        imgDialogVisible: false,
        dialogImageUrl: '',
        baseImgUrl: baseImgUrl + '/',
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getStyle() {
        return (val) => {
          switch (val) {
            case 2:
              return 'color: rgba(51, 136, 255, 1);';
            case 1:
              return 'color: rgba(249, 166, 6, 1)';
            case 3:
              return 'color:#F56C6C;';
            case 4:
              return 'color:#F56C6C;';
          }
        };
      },
      // 审核状态
      getState() {
        return function(state, operationPower) {
          switch (true) {
            case operationPower === 0:
              return '已通过';
            case state === 1 && operationPower === 1:
              return '待审核';
            case state === 2 && operationPower === 1:
              return '已通过';
            case state === 3 && operationPower === 1:
              return '已拒绝';
            case state === 4 && operationPower === 1:
              return '已取消';
          }
        };
      },
      //操作类型
      operationTypeFormat() {
        return function(value) {
          switch (value) {
            case 0:
              return '新增';
            case 1:
              return '信息变更';
            case 2:
              return '终止合作';
          }
        };
      },

    },
    mounted() {
      this.init();
      this.regionList = JSON.parse(getSessionStore('areaList'));
    },
    methods: {
      async init() {
        await this._highwaySupplierAuditPageList();
      },
      async _highwaySupplierAuditPageList() {
        let str = '';
        if (this.addressIpt) {
          this.addressIpt.forEach((item, index) => {
            if (index !== this.addressIpt.length - 1) {
              str += item + ',';
            } else {
              str += item;
            }
          });
        }
        this.tableLoad = true;
        const res = await highwaySupplierAuditPageList(
          {
            name: this.entrustIpt,
            account: this.tellIpt,
            serviceRegionId: str,
            examine: this.stateIpt,
            page: this.page,
            rows: this.size,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) this.$message.error(res.message);
        this.total = res.data.total;
        this.TableDatas = res.data.records;
      },
      async refusedClick() {
        this.remark = this.remark.trim();
        if (!this.remark) return this.$message.warning('请填写拒绝理由！');
        const res = await highwaySupplierReviewSubmit({
          id: this.activeId,
          auditOpinion: this.remark,
          reviewResult: 'REFUSE',
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.detailDialogVisible = false;
        await this._highwaySupplierAuditPageList();
      },
      async agreeClick() {
        this.remark = this.remark.trim();
        if (!this.remark) return this.$message.warning('请填写同意理由！');
        const res = await highwaySupplierReviewSubmit({
          id: this.activeId,
          auditOpinion: this.remark,
          reviewResult: 'AGREE',
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.detailDialogVisible = false;
        await this._highwaySupplierAuditPageList();
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._highwaySupplierAuditPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._highwaySupplierAuditPageList();
      },
      disableClick(id) {
        this.$confirm('确认拒绝当前委托商申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.activeId = id;
            this.reason = '';
            this.reasonTitle = '拒绝原因';
            this.reasonVisible = true;
          })
          .catch(() => {
          });
      },
      imgClick(val, name) {
        const arr = ['.jpeg', '.png', '.jpg', '.JPG', '.gif', '.PNG'];
        let str = name.substring(name.indexOf('.'));
        if (arr.indexOf(str) === -1) return this.$message.warning('只有图片类型附件才可以预览！');
        let token = getSessionStore('token');
        this.dialogImageUrl = baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (val.id || val.response.data.id) + '&access_token=' + token;
        this.imgDialogVisible = true;
      },
      //详情附件下载
      downloadClick(id) {
        let token = getSessionStore('token');
        window.location.href = baseUrl + '/web/attachmentFtp/download?attachmentId=' + id + '&access_token=' +
          token;
      },
      /**
       * 详情
       * @param id
       * @param operationPower 权限
       * @returns {Promise<void>}
       */
      async detailClick(id, operationPower) {
        this.remark = '';
        this.activeId = id;
        this.detailDialogVisible = true;
        const res = await highwaySupplierAuditDetail({ 'id': id });
        if (res.status !== 0) this.$message.error(res.message);
        const arr1 = res.data.leader.split(',');
        const arr2 = res.data.leaderPhone.split(',');
        const arr3 = res.data.leaderPosition.split(',');
        const arr = [];
        arr1.forEach((item, index) => arr.push({
          name: item,
          tell: arr2[index],
          position: arr3[index],
        }));
        this.detailData = {
          ...res.data,
          person: arr,
          typeName: res.data.serviceRegionName.split(','),
          attachData: [],
          operationPower: operationPower,
        };
        if (res.data.attachmentList && res.data.attachmentList.length > 0) {
          this.detailData.attachData = res.data.attachmentList.map(item => {
            return {
              name: item.attachmentName,
              time: item.uploadTime,
              url: item.attachmentGroup + '/' + item.attachmentPath,
              status: 'success',
              id: item.id,
            };
          });
        }
        // 审核信息
        this.stepData = [];
        if (res.data.auditRecordList && res.data.auditRecordList.length > 0) {
          res.data.auditRecordList.forEach((item) => {
            let status = '',
              temp = {
                title: '',
                time: '',
                state: '',
                remark: '',
              },
              text = '取消审核';
            if (item.status == 1) {
              text = '发起';
            }
            if (item.status == 0) {
              text = '重新发起';
            }
            if (item.status == 3) {
              status = 'failure', text = '拒绝';
              temp = {
                'title': (item.deptName || '') + ' ' + (item.auditorName || '') + ' ' + text,
                'time': (item.createTime || ''),
                'state': status,
                'remark': (item.opinion || ''),
              };
            } else if (item.status == 2) {
              status = 'success', text = '同意';
              temp = {
                'title': (item.deptName || '') + ' ' + (item.auditorName || '') + ' ' + text,
                'time': (item.createTime || ''),
                'state': status,
                'remark': (item.opinion || ''),
              };
            } else {
              temp = {
                'title': (item.auditorName || '') + ' ' + text,
                'time': (item.createTime || ''),
                'state': status,
                'remark': (item.opinion || ''),
              };
            }
            this.stepData.push(temp);
          });
        }
      },
      searchBtn() {
        this.page = 1;
        this._highwaySupplierAuditPageList();
      },
      resetBtn() {
        this.entrustIpt = '';
        this.tellIpt = '';
        this.enterIpt = '';
        this.stateIpt = '';
      },
      enableClick(id) {
        this.$confirm('确认同意当前委托商申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.activeId = id;
            this.reason = '';
            this.reasonTitle = '同意原因';
            this.reasonVisible = true;
          })
          .catch(() => {
          });
      },
      async reasonClick() {
        this.reason = this.reason.trim();
        if (!this.reason) return this.$message.warning(this.reasonTitle === '同意原因' ? '请填写同意原因！' : '请填写拒绝原因!');
        const res = await highwaySupplierReviewSubmit({
          id: this.activeId,
          auditOpinion: this.reason,
          reviewResult: this.reasonTitle === '同意原因' ? 'AGREE' : 'REFUSE',
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.reasonVisible = false;
        await this._highwaySupplierAuditPageList();
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #F56C6C !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        .attachment {
          display: flex;
          flex-direction: column;
          padding-top: 10px;

          &Item {
            width: 80%;
            margin-bottom: 10px;
            margin-left: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
              color: #969696;
              font-size: 14px;
            }
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px;

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input__inner {
          border: none;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
